<template>
  <div>
    <v-dialog :value="isContentPackDialogVisible" max-width="560" @input="$emit('update:isContentPackDialogVisible', $event)">
      <v-card>
        <v-card-title>Select Content Pack</v-card-title>
        <v-card-text>
          <v-select
            :value="selectedContentPackId"
            :items="contentPackOptions"
            label="Content Pack"
            outlined
            @input="$emit('update:selectedContentPackId', $event)"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$emit('cancel-selection')">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="!selectedContentPackId" @click="$emit('continue-selection')">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog :value="isAcademyDialogVisible" max-width="560" @input="$emit('update:isAcademyDialogVisible', $event)">
      <v-card>
        <v-card-title>{{ academyDialogTitle }}</v-card-title>
        <v-card-text>
          <v-select
            :value="selectedAcademyId"
            :items="academyOptions"
            label="Academy"
            outlined
            @input="$emit('update:selectedAcademyId', $event)"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$emit('cancel-academy-selection')">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="!selectedAcademyId" @click="$emit('continue-academy-selection')">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="isContentPackConfirmationDialogVisible"
      max-width="720"
      @input="$emit('update:isContentPackConfirmationDialogVisible', $event)"
    >
      <v-card>
        <v-card-title>{{ contentPackConfirmationTitle }}</v-card-title>
        <v-card-text>
          <p>{{ contentPackConfirmationMessage }}</p>
          <v-list dense class="py-0">
            <v-list-item v-for="item in selectedItems" :key="item.id">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$emit('close-confirmation')">
            Cancel
          </v-btn>
          <v-btn color="primary" :loading="isBulkUpdating" @click="$emit('confirm-selection')">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="isAcademyConfirmationDialogVisible"
      max-width="720"
      @input="$emit('update:isAcademyConfirmationDialogVisible', $event)"
    >
      <v-card>
        <v-card-title>{{ academyConfirmationTitle }}</v-card-title>
        <v-card-text>
          <p>{{ academyConfirmationMessage }}</p>
          <v-list dense class="py-0">
            <v-list-item v-for="item in selectedItems" :key="item.id">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$emit('close-academy-confirmation')">
            Cancel
          </v-btn>
          <v-btn color="primary" :loading="isBulkUpdating" @click="$emit('confirm-academy-selection')">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    selectedItems: {
      type: Array,
      required: true,
    },
    contentPackOptions: {
      type: Array,
      required: true,
    },
    academyOptions: {
      type: Array,
      default: () => [],
    },
    selectedContentPackId: {
      type: [String, Number, null],
      default: null,
    },
    selectedAcademyId: {
      type: [String, Number, null],
      default: null,
    },
    isContentPackDialogVisible: {
      type: Boolean,
      required: true,
    },
    isAcademyDialogVisible: {
      type: Boolean,
      default: false,
    },
    isContentPackConfirmationDialogVisible: {
      type: Boolean,
      required: true,
    },
    isAcademyConfirmationDialogVisible: {
      type: Boolean,
      default: false,
    },
    isBulkUpdating: {
      type: Boolean,
      default: false,
    },
    contentPackConfirmationTitle: {
      type: String,
      required: true,
    },
    contentPackConfirmationMessage: {
      type: String,
      required: true,
    },
    academyDialogTitle: {
      type: String,
      default: 'Select Academy',
    },
    academyConfirmationTitle: {
      type: String,
      default: 'Update Academy',
    },
    academyConfirmationMessage: {
      type: String,
      default: '',
    },
  },
}
</script>
